import React, { Component } from "react";
import Link from "gatsby-link";
import styles from "./opportunity-item.module.scss";

class OpportunityItem extends Component {
	
	render() {
		const {props} = this;
	
		return (
			<div className={"row justify-content-between " + styles.opportunity_item}>
				<div className="col-12 col-lg-5">
					<div className="row justify-content-center">
						<div className="col-12 col-lg-11">
							<h3><Link to={props.url}>{props.title}</Link></h3>
							<span>
							{props.location}
							</span>
						</div>
					</div>
				</div>
				<div className="col-12 col-lg-6">
					<p>
					{props.description}
					</p>
					<Link to={props.url}>Read more &raquo;</Link>
				</div>
			</div>
		);
	}
}




export default OpportunityItem;



// WEBPACK FOOTER //
// ./src/components/opportunity-item/index.js